import { isEqual } from "lodash";

import store from "store/store";
import {
	setAwardsAvailableColumns,
	setProjectsAvailableColumns,
	setProposalsAvailableColumns,
} from "../actions/columns";


const currentValue = {
	awards: [],
	projects: [],
	proposals: [],
};

const set = {
	awards: setAwardsAvailableColumns,
	projects: setProjectsAvailableColumns,
	proposals: setProposalsAvailableColumns,
};

const handleInitColumnHeaders = (type) => {
	let previousValue = currentValue[type];
	currentValue[type] = store.getState().tenant.formColumnHeaders ?? {};

	if (!isEqual(previousValue, currentValue[type])) {
		set[type](currentValue[type]);
	}
};

export const subscribeFormColumnHeaders = () => {
	store.subscribe(() => handleInitColumnHeaders('awards'));
	store.subscribe(() => handleInitColumnHeaders('projects'));
	store.subscribe(() => handleInitColumnHeaders('proposals'));
};
